import React from 'react'
import ChatDummyIcon from '../../../Assets/Images/icons/chatDummy'

const ChatDummy = () => {
  return (
    <div
      style={{
        width: '100%',
        height: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexDirection: 'column',
      }}
    >
      <ChatDummyIcon width={150} height={150} />
      <h3 cypress_id={'noMsgText'}>No messages in your inbox yet!</h3>
      <p>Start chatting!</p>
    </div>
  )
}

export default ChatDummy
